import Vue from 'vue'
import router from '@/router'
import store from '@/store'

// js动态控制屏幕的基准值
(function (win) {
  var doc = win.document
  var docEl = doc.documentElement
  var tid

  function refreshRem () {
    var width = docEl.getBoundingClientRect().width
    if (width > 540) { // 最大宽度
      width = 540
    }
    var rem = width / 10 // 将屏幕宽度分成10份， 1份为1rem
    docEl.style.fontSize = rem + 'px'
  }

  win.addEventListener('resize', function () {
    clearTimeout(tid)
    tid = setTimeout(refreshRem, 300)
  }, false)
  win.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(tid)
      tid = setTimeout(refreshRem, 300)
    }
  }, false)
  refreshRem()
})(window)

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  Vue.cookie.delete('Token')
  localStorage.removeItem('id')
  localStorage.removeItem('name')
  store.commit('resetStore')
}

/**
 * 查询该数组是否包含ID
 */
export function isArrayId (id, array) {
  if(array){
    return array.includes(id)
  } else {
    return false
  }
}

/**
 * 长链接
 */
export function websoket (userId) {
  let ws = new WebSocket('ws://chinajiemuku.com/websocket/dashboard/'+userId); 
  // let ws = new WebSocket('ws://192.168.10.37:8084/dashboard/'+userId);
  // let ws = new WebSocket('ws://guoshi.getf.vip/websocket/dashboard/'+userId);
  return ws;
}


/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}


// WEBPACK FOOTER //
// ./src/utils/index.js